import { Component, output, type OnInit } from '@angular/core';
import { CdkStep } from '@angular/cdk/stepper';

import { type IDialog, type IDialogOptions } from '../dialog';
import { GetStartedStepperComponent } from '../../components/get-started-stepper/get-started-stepper.component';

/**
 * Welcome options.
 */
export type WelcomeOptions = Readonly<{

	/**
	 * Dialog title.
	 */
	title?: string;

	/**
	 * Welcome message.
	 */
	message?: string;
}>;

/**
 * Welcome let's get started dialog component.
 */
@Component({
	selector: 'protctc-welcome-dialog',
	templateUrl: './welcome-dialog.component.html',
	styleUrls: ['./welcome-dialog.component.css'],
	imports: [CdkStep, GetStartedStepperComponent],
})
export class WelcomeDialogComponent implements IDialog<WelcomeOptions, void>, OnInit {
	/** @inheritdoc */
	public options: IDialogOptions = {};

	/** @inheritDoc */
	public readonly closed = output();

	/** @inheritdoc */
	public readonly props!: WelcomeOptions;

	/** Default dialog property values. */
	private readonly defaultProps: WelcomeOptions = {
		title: `Welcome to Pantera Software`,
	};

	/**
	 * @inheritdoc
	 */
	public ngOnInit(): void {
		this.options = {
			closable: true,
			closeButton: true,
			title: this.props?.title ?? this.defaultProps.title,
		};
	}
}
